import { useWizard } from "react-use-wizard";
import { TKeyOfDataWizardBuy, TNumberKeysOfIFillDataWizardBuy } from "../../..";
import buySteps from "../../buySteps";
import FacilityTypeStep from "../../../../../../../shared/wizard/steps/facilityTypeStep";

interface ISelectionByOwnSwapStep_7 {
  isNextStepDisabled: boolean;
  onChange: (data: number[], key: TNumberKeysOfIFillDataWizardBuy) => void;
  data: number[] | null;
  onReset: (key: TKeyOfDataWizardBuy[], data: number[]) => void;
}

const SelectionByOwnSwapStep_7 = ({
  isNextStepDisabled,
  data,
  onChange,
  onReset,
}: ISelectionByOwnSwapStep_7) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.selectionSteps.swap.step_6);
    if (data) {
      onReset(["selectedFacilityTypeIds"], [data[0]]);
    }
  };

  const handleNextStep = () => {
    goToStep(buySteps.selectionSteps.swap.step_8);
  };

  const handleChange = (selectedId: number) => {
    if (data?.includes(selectedId)) {
      const dataFiltered = data.filter((id) => id !== selectedId);
      if (dataFiltered) {
        onChange(dataFiltered, "selectedFacilityTypeIds");
      }
    } else {
      if (data && data.length <= 2) {
        onChange([data[0], selectedId], "selectedFacilityTypeIds");
      }
    }
  };

  return (
    <div>
      <FacilityTypeStep
        isNextStepDisabled={isNextStepDisabled}
        onChange={handleChange}
        onNextStep={handleNextStep}
        onPrevStep={handlePrevStep}
        data={data}
        mode="repeat"
      />
    </div>
  );
};

export default SelectionByOwnSwapStep_7;
